import React from 'react';
import { Check, XOctagon } from 'lucide-react';
import { ACCEPTANCE_POLICY } from '@/data/site';

/**
 * Reusable side-by-side "Accepts / Does Not Accept" policy blocks.
 * Used inside the CannotTake section and on the Contact page acceptance gate.
 */
export default function AcceptancePolicyBlocks({ compact = false }) {
  const padding = compact ? 'p-6 sm:p-7' : 'p-7 md:p-9';
  const titleSize = compact ? 'text-xl md:text-2xl' : 'text-2xl md:text-3xl';

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-testid="acceptance-policy-blocks">
      {/* Accepts */}
      <div
        className={`rounded-2xl border-2 border-ohana-accent/40 bg-white ${padding}`}
        data-testid="acceptance-accepts"
      >
        <div className="flex items-center gap-3">
          <span className="grid h-10 w-10 place-items-center rounded-xl bg-ohana-accent text-white">
            <Check className="h-5 w-5" strokeWidth={3} />
          </span>
          <p className="overline !text-ohana-accent">Accepted</p>
        </div>
        <h3 className={`mt-4 font-serif ${titleSize} text-ohana-primary leading-tight`}>
          {ACCEPTANCE_POLICY.accepts.title}
        </h3>
        <p className="mt-4 text-ohana-text leading-relaxed">{ACCEPTANCE_POLICY.accepts.text}</p>
      </div>

      {/* Does Not Accept */}
      <div
        className={`rounded-2xl border-2 border-ohana-primary bg-ohana-primary text-ohana-bg ${padding}`}
        data-testid="acceptance-does-not-accept"
      >
        <div className="flex items-center gap-3">
          <span className="grid h-10 w-10 place-items-center rounded-xl bg-ohana-bg text-ohana-primary">
            <XOctagon className="h-5 w-5" strokeWidth={2.5} />
          </span>
          <p className="overline">Not Accepted</p>
        </div>
        <h3 className={`mt-4 font-serif ${titleSize} leading-tight`}>
          {ACCEPTANCE_POLICY.doesNotAccept.title}
        </h3>
        <p className="mt-4 text-ohana-bg/85 leading-relaxed">
          {ACCEPTANCE_POLICY.doesNotAccept.text}
        </p>
      </div>
    </div>
  );
}
